const HomeOnTheRange = [
	'[VERSE 1]',
	'Oh give me a home where the buffalo roam',
	'Where the deer and the antelope play',
	'Where seldom is heard a discouraging word',
	'And the skies are not cloudy all day',
	'',
	'[CHORUS]',
	'Home home on the range',
	'Where the deer and the antelope play',
	'Where seldom is heard a discouraging word',
	'And the skies are not cloudy all day',
	'',
	'[VERSE 2]',
	'The Red Man was pressed from this part of the west',
	"It's not likely he'll ever return",
	'To the banks of Red River where seldom if ever',
	'His flickering campfires still burn',
	'',
	'Repeat chorus',
	'Home home on the range',
	'Where the deer and the antelope play',
	'Where seldom is heard a discouraging word',
	'And the skies are not cloudy all day',
	'',
	'[VERSE 3]',
	'How often at night when the heavens are bright',
	'With the light from the glittering stars',
	'Have I stood there amazed and asked as I gazed',
	'If their glory exceeds that of ours',
	'',
	'Repeat chorus',
	'Home home on the range',
	'Where the deer and the antelope play',
	'Where seldom is heard a discouraging word',
	'And the skies are not cloudy all day',
	'',
	'[VERSE 4]',
	'Oh give me a land where the bright diamond sand',
	'Flows leisurely down the stream',
	'Where the graceful white swan goes gliding along',
	'Like a maid in a heavenly dream',
	'',
	'[CHORUS]',
	'Home home on the range',
	'Where the deer and the antelope play',
	'Where seldom is heard a discouraging word',
	'And the skies are not cloudy all day',
	'And the skies are not cloudy all day',
];

export default HomeOnTheRange;
